const FeedbackSubjectIndex = () => import('./views/FeedbackSubjectIndex.vue')
const FeedbackSubjectCreate = () => import('./views/FeedbackSubjectCreate.vue')
const FeedbackSubjectEdit = () => import('./views/FeedbackSubjectEdit.vue')

export default [
  {
    path: 'feedback/subject',
    name: 'feedback.subject.index',
    component: FeedbackSubjectIndex
  },
  {
    path: 'feedback/subject/create',
    name: 'feedback.subject.create',
    component: FeedbackSubjectCreate
  },
  {
    path: 'feedback/subject/:subjectId(\\d+)',
    name: 'feedback.subject.edit',
    component: FeedbackSubjectEdit
  }
]
